import type { Checkin } from '~/types';

export const getTitle = ({ checkin }: { checkin: Checkin }): string => {
  let title = checkin.title;

  if (!title) {
    title = [
      checkin.producer || checkin.brand,
      checkin.country || checkin.region,
      checkin.processingMethod,
    ].filter((a): a is string => !!(a && typeof a === 'string')).join(' ');
  }

  return title.trim();
};
